import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#020408',
    },
    secondary: {
      main: '#888C8C',
    },
  },
});

//#8C1127 Vino tinto
//#BF213E Rojo
//#590C29 Rojo/Café
//#888C8C Gris
//#020408 Negro
//Amarillo #fff000
//Azul #205ba7

export default theme;
